import { Component, Input } from '@angular/core';
import { CoverageModal } from './coverage-modal.component';
import { CoverageModalOptions } from './models/coverage-modal-options.model';
import { ModalOptions } from './models/modal-options.model';
import { ModalService } from './modal.service';
import { GenericsHelperMethods } from './generics-helper-methods';
import { SpanLinkComponent } from './span-link.component';
import { CoverageService } from './coverage.service';
import { ApiQuoteResponse } from '@bhtp-client-api/base';

@Component({
    selector: 'coverage-modal-link',
    template: require('./coverage-modal-link.component.html'),
    providers: [ModalService, CoverageService]
})
export class CoverageModalLinkComponent extends SpanLinkComponent {
    @Input() public product: ApiQuoteResponse = null;

    /**
     *  Is the current coverage data for a trip that was purchased?
     *      The coverage modal shows optional coverages if the trip was purchased.
     */
    @Input() public wasPurchased: boolean = false;

    @Input() public showDocLink: boolean = false;

    constructor(protected modalService: ModalService, private coverageService: CoverageService) {
        super(modalService);
    };

    public getModalOptions(): ModalOptions {
        let cloneProduct: ApiQuoteResponse = JSON.parse(JSON.stringify(this.product));

        // create modal options.
        let options = new CoverageModalOptions();
        options.product = [];
        options.product.push(cloneProduct);
        options.product = this.coverageService.remapBonusCoverages(options.product);
        options.wasPurchased = this.wasPurchased;
        options.showDocLink = this.showDocLink;
        options.showPackageModalHeader = true;
        options.showHeader = false;

        return options;
    }

    protected onClicked(event: Event): void {
        // options are built in a separate method so the method can be overridden by derived types.
        let options: ModalOptions = this.getModalOptions();

        // use the modal service to create the modal and backdrop dynamically.
        this.modalService.showModal(CoverageModal, options);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/coverage-modal-link.component.ts